import { HighlightLayer as BabylonHighlightLayer } from '@babylonjs/core/Layers/highlightLayer';
import { Color3 } from '@babylonjs/core/Maths/math.color';
import { Mesh } from '@babylonjs/core/Meshes/mesh';
import { Scene } from '@babylonjs/core/scene';

import ArticleNode from '../../nodes/articleNode';
import Settings from '../../settings/settings';

export default class HighlightLayer {
  private readonly color: Color3;
  private highlightLayer: BabylonHighlightLayer;
  private highlightedArticle: ArticleNode;

  constructor(name: string, scene: Scene, color = Settings.BRAND_COLOR) {
    this.color = color;
    this.highlightLayer = new BabylonHighlightLayer(name, scene, {
      isStroke: true,
      blurTextureSizeRatio: 0.7,
      mainTextureFixedSize: 2048,
    });
    this.highlightLayer.innerGlow = false;
  }

  public get currentHighlightedArticle(): ArticleNode {
    return this.highlightedArticle;
  }

  public highlight(article: ArticleNode) {
    this.clearHighlights();
    this.highlightedArticle = article;

    this.highlightedArticle.allMeshes.forEach((mesh) => {
      try {
        this.highlightLayer.addMesh(mesh as Mesh, this.color);
      } catch (error) {
        console.debug('Mesh is not supported for highlighting.', mesh.name);
      }
    });
  }

  public clearHighlights() {
    if (this.highlightedArticle) {
      this.highlightedArticle.allMeshes.forEach((mesh) =>
        this.highlightLayer.removeMesh(mesh as Mesh),
      );
      this.highlightedArticle = null;
    }
  }
}
